module.exports = __webpack_public_path__ + "img/settings_input_hdmi.711ae995.svg";